module.exports = __webpack_public_path__ + "img/c2.f57f57da.png";